import type { InfiniteData } from "@tanstack/react-query";
import type {
	TimelineItemResponseDTO,
	TimelineResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { getTimelineNotificationIds } from "web_myplann/NotificationCenter/Utils/getNotificationIdsToMarkRead";

export type RecentTimelineData = InfiniteData<TimelineResponseDTO, number>;

const touchesAny = (
	item: TimelineItemResponseDTO,
	ids: ReadonlySet<number>,
): boolean => getTimelineNotificationIds(item).some((id) => ids.has(id));

export const markTimelineItemsRead = (
	data: RecentTimelineData | undefined,
	ids: ReadonlySet<number>,
): RecentTimelineData | undefined => {
	if (!data || ids.size === 0) {
		return data;
	}
	return {
		...data,
		pages: data.pages.map((page) => ({
			...page,
			items: page.items.map((item) =>
				!item.isRead && touchesAny(item, ids)
					? { ...item, isRead: true }
					: item,
			),
		})),
	};
};
